module.exports = __webpack_public_path__ + "img/icon_finance@2x.2425c32e.png";